import MyExecutionMilestonesPage from "../../shared/project-execution-plan/MyExecutionMilestonesPage";

const ContractorExecutionMilestonesPage = () => (
  <MyExecutionMilestonesPage role="Contractor" />
);

export default ContractorExecutionMilestonesPage;
